<ng-container *ngFor="let bc of breadcrumbs; let last = last">
    <a [routerLink]="bc.link">{{
        bc.label
        }}</a>
    <span *ngIf="!last"> ▸ </span>
</ng-container>
